import { Link } from 'react-router-dom'

export default function NotFound() {
  return (
    <div style={{ marginTop: '240px', textAlign: 'center' }}>
      404 page not found, back to <Link to="/">Home Page</Link>
    </div>
  )
}
